import { GetLayout } from "components/get-layout";

export function ExtratoOnlineLote() {
  return (
    <GetLayout>
      <></>
    </GetLayout>
  );
}
